/* home - faq section js start */
class KgFaqAccordion extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.kg-faq-accordion-item'));

    this.items.forEach((item) => {
      const trigger = item.querySelector('.kg-faq-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        const wasOpen = item.classList.contains('is-open');

        this.items.forEach((other) => {
          other.classList.remove('is-open');
          other.querySelector('.kg-faq-trigger')?.setAttribute('aria-expanded', 'false');
        });

        if (!wasOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
}

if (!customElements.get('kg-faq-accordion')) {
  customElements.define('kg-faq-accordion', KgFaqAccordion);
}

/* home - faq section js end */

/* home - gallery section js start */
function closeKgGalleryModal(modal) {
  if (!modal) return;

  const iframe = modal.querySelector('iframe');
  if (iframe) {
    iframe.src = '';
  }

  const video = modal.querySelector('video');
  if (video) {
    video.pause();
    video.currentTime = 0;
  }

  modal.close();
}

class KgGalleryVideo extends HTMLElement {
  connectedCallback() {
    this.playButton = this.querySelector('.kg-gallery-play');
    this.modalId = this.playButton?.getAttribute('data-modal-id');

    this.playButton?.addEventListener('click', () => this.openModal());
  }

  openModal() {
    const modal = this.modalId ? document.getElementById(this.modalId) : null;
    if (!modal) return;

    modal.showModal();

    const iframe = modal.querySelector('iframe[data-src]');
    if (iframe && iframe.dataset.src) {
      iframe.src = iframe.dataset.src;
    }

    const video = modal.querySelector('video');
    if (video) {
      video.play();
    }
  }
}

if (!customElements.get('kg-gallery-video')) {
  customElements.define('kg-gallery-video', KgGalleryVideo);
}

document.addEventListener('click', (event) => {
  const closeButton = event.target.closest('.kg-gallery-modal__close');
  if (closeButton) {
    closeKgGalleryModal(closeButton.closest('dialog'));
    return;
  }

  const modal = event.target;
  if (modal.tagName === 'DIALOG' && modal.classList.contains('kg-gallery-modal')) {
    closeKgGalleryModal(modal);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const modal = document.querySelector('.kg-gallery-modal[open]');
  if (modal) {
    closeKgGalleryModal(modal);
  }
});

/* home - gallery section js end */

/* home - more than mats section js start */
function closeKgMatsModal(modal) {
  if (!modal) return;

  const iframe = modal.querySelector('iframe');
  if (iframe) {
    iframe.src = '';
  }

  const video = modal.querySelector('video');
  if (video) {
    video.pause();
    video.currentTime = 0;
  }

  modal.close();
}

document.addEventListener('click', (event) => {
  const playBtn = event.target.closest('.kg-more-than-mats .kg-more-than-mats__play-btn');
  if (playBtn) {
    const modalId = playBtn.getAttribute('data-modal-id');
    const modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return;

    modal.showModal();

    const iframe = modal.querySelector('iframe[data-src]');
    if (iframe && iframe.dataset.src) {
      iframe.src = iframe.dataset.src;
    }

    const video = modal.querySelector('video');
    if (video) {
      video.play();
    }

    return;
  }

  const closeBtn = event.target.closest('.kg-more-than-mats__modal-close');
  if (closeBtn) {
    closeKgMatsModal(closeBtn.closest('dialog'));
  }
});

document.addEventListener('click', (event) => {
  const modal = event.target;
  if (modal.tagName === 'DIALOG' && modal.classList.contains('kg-more-than-mats__modal')) {
    closeKgMatsModal(modal);
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const modal = document.querySelector('.kg-more-than-mats__modal[open]');
  if (modal) {
    closeKgMatsModal(modal);
  }
});

/* home - more than mats section js end */

/* testimonials section js start */
class KgTestimonialsSlider extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.kg-testimonials__viewport');
    this.track = this.querySelector('.kg-testimonials__track');
    this.prevBtn = this.querySelector('.kg-testimonials__nav-btn--prev');
    this.nextBtn = this.querySelector('.kg-testimonials__nav-btn--next');
    this.loop = this.dataset.loop !== 'false';
    this.autoplayEnabled =
      this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;

    if (!this.track) return;

    this.realSlides = Array.from(this.querySelectorAll('.kg-testimonials__slide'));
    this.totalReal = this.realSlides.length;

    if (this.totalReal === 0) return;

    const initialActive = this.realSlides.findIndex((slide) => slide.classList.contains('is-active'));
    this.realActiveIndex = initialActive >= 0 ? initialActive : 0;

    if (this.loop && this.totalReal > 1) {
      this.setupInfiniteLoop();
    } else {
      this.slides = this.realSlides;
      this.currentIndex = this.realActiveIndex;
    }

    this.isAnimating = false;
    this.isPaused = false;
    this.autoplayTimer = null;

    this.prevBtn?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
    this.nextBtn?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

    this.viewport?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.goTo(this.currentIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.goTo(this.currentIndex + 1);
      }
    });

    this.onTransitionEnd = (event) => {
      if (event.target !== this.track || event.propertyName !== 'transform') return;
      this.onSlideTransitionEnd();
    };

    this.track.addEventListener('transitionend', this.onTransitionEnd);

    this.onResize = () => this.applyTransform(false);
    window.addEventListener('resize', this.onResize);

    this.resizeObserver = new ResizeObserver(() => this.applyTransform(false));
    if (this.viewport) {
      this.resizeObserver.observe(this.viewport);
    }

    this.bindTouchEvents();
    this.bindAutoplayEvents();
    this.setInstant(true);
    this.updateActiveState();
    this.applyTransform(false);
    this.finishInstantReset(() => this.scheduleAutoplay());
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.visibilityObserver?.disconnect();
    this.track?.removeEventListener('transitionend', this.onTransitionEnd);
    this.clearAutoplay();

    if (this.onResize) {
      window.removeEventListener('resize', this.onResize);
    }
  }

  setupInfiniteLoop() {
    const prependFragment = document.createDocumentFragment();
    const appendFragment = document.createDocumentFragment();

    this.realSlides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add('kg-testimonials__slide--clone');
      clone.removeAttribute('data-shopify-editor-block');
      prependFragment.appendChild(clone);
    });

    this.realSlides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add('kg-testimonials__slide--clone');
      clone.removeAttribute('data-shopify-editor-block');
      appendFragment.appendChild(clone);
    });

    this.track.insertBefore(prependFragment, this.track.firstChild);
    this.track.appendChild(appendFragment);

    this.slides = Array.from(this.track.querySelectorAll('.kg-testimonials__slide'));
    this.currentIndex = this.totalReal + this.realActiveIndex;
  }

  bindAutoplayEvents() {
    if (!this.autoplayEnabled || this.totalReal <= 1) return;

    this.onMouseEnter = () => this.pauseAutoplay();
    this.onMouseLeave = () => this.resumeAutoplay();
    this.onFocusIn = () => this.pauseAutoplay();
    this.onFocusOut = (event) => {
      if (!this.contains(event.relatedTarget)) {
        this.resumeAutoplay();
      }
    };

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('focusout', this.onFocusOut);

    this.visibilityObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.resumeAutoplay();
          } else {
            this.pauseAutoplay();
          }
        });
      },
      { threshold: 0.2 }
    );

    this.visibilityObserver.observe(this);
  }

  bindTouchEvents() {
    if (!this.viewport) return;

    let startX = 0;
    let isDragging = false;

    this.viewport.addEventListener(
      'touchstart',
      (event) => {
        startX = event.touches[0].clientX;
        isDragging = true;
        this.pauseAutoplay();
      },
      { passive: true }
    );

    this.viewport.addEventListener(
      'touchend',
      (event) => {
        if (!isDragging) return;

        const endX = event.changedTouches[0].clientX;
        const delta = startX - endX;

        if (Math.abs(delta) > 40) {
          this.goTo(this.currentIndex + (delta > 0 ? 1 : -1));
        }

        isDragging = false;
        this.resumeAutoplay();
      },
      { passive: true }
    );
  }

  clearAutoplay() {
    if (this.autoplayTimer) {
      clearTimeout(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  scheduleAutoplay() {
    this.clearAutoplay();

    if (!this.autoplayEnabled || this.totalReal <= 1 || this.isPaused || this.isAnimating) return;

    this.autoplayTimer = setTimeout(() => {
      this.goTo(this.currentIndex + 1);
    }, this.autoplaySpeed);
  }

  pauseAutoplay() {
    this.isPaused = true;
    this.clearAutoplay();
  }

  resumeAutoplay() {
    if (!this.autoplayEnabled || this.totalReal <= 1) return;

    this.isPaused = false;
    this.scheduleAutoplay();
  }

  goTo(index) {
    if (this.totalReal <= 1 || this.isAnimating) return;

    this.clearAutoplay();

    if (this.loop && this.slides.length > this.totalReal) {
      this.currentIndex = index;
    } else {
      this.currentIndex = Math.max(0, Math.min(index, this.totalReal - 1));
    }

    this.isAnimating = true;
    this.setInstant(false);
    this.updateActiveState();
    this.applyTransform(true);
  }

  onSlideTransitionEnd() {
    if (this.normalizePosition()) return;
    this.isAnimating = false;
    this.scheduleAutoplay();
  }

  normalizePosition() {
    if (!this.loop || this.totalReal <= 1) return false;

    let nextIndex = this.currentIndex;

    if (this.currentIndex < this.totalReal) {
      nextIndex = this.currentIndex + this.totalReal;
    } else if (this.currentIndex >= this.totalReal * 2) {
      nextIndex = this.currentIndex - this.totalReal;
    }

    if (nextIndex === this.currentIndex) return false;

    this.currentIndex = nextIndex;
    this.setInstant(true);
    this.updateActiveState();
    this.applyTransform(false);
    this.finishInstantReset(() => {
      this.isAnimating = false;
      this.scheduleAutoplay();
    });

    return true;
  }

  setInstant(enabled) {
    this.track?.classList.toggle('is-instant', enabled);
    this.slides?.forEach((slide) => slide.classList.toggle('is-instant', enabled));
  }

  finishInstantReset(callback) {
    void this.track?.offsetHeight;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.setInstant(false);
        callback?.();
      });
    });
  }

  updateActiveState() {
    this.slides.forEach((slide, index) => {
      const isActive = index === this.currentIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  applyTransform(animate = true) {
    const activeSlide = this.slides[this.currentIndex];
    if (!activeSlide || !this.viewport || !this.track) return;

    if (!animate) {
      this.setInstant(true);
    }

    const viewportWidth = this.viewport.offsetWidth;
    const slideWidth = activeSlide.offsetWidth;
    const slideLeft = activeSlide.offsetLeft;
    const offset = slideLeft - (viewportWidth - slideWidth) / 2;

    this.track.style.transform = `translate3d(-${offset}px, 0, 0)`;

    if (!animate) {
      void this.track.offsetHeight;
    }
  }
}

if (!customElements.get('kg-testimonials-slider')) {
  customElements.define('kg-testimonials-slider', KgTestimonialsSlider);
}

/* testimonials section js end */

/* product - tabs section js start */
class KgProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.kg-product-tabs__tab'));
    this.panels = Array.from(this.querySelectorAll('.kg-product-tabs__panel'));

    if (this.tabs.length === 0) return;

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activateTab(index));

      tab.addEventListener('keydown', (event) => {
        let nextIndex = null;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % this.tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        }

        if (nextIndex !== null) {
          event.preventDefault();
          this.activateTab(nextIndex);
          this.tabs[nextIndex].focus();
        }
      });
    });
  }

  activateTab(index) {
    this.tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;

      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === index;

      panel.classList.toggle('is-active', isActive);

      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }
}

if (!customElements.get('kg-product-tabs')) {
  customElements.define('kg-product-tabs', KgProductTabs);
}

/* product - tabs section js end */